import { useMemo } from 'react';
import { getDatePickerDateType } from 'ui';
import type { SlotStart } from 'features/calendar';
import { useFormatTime, useGenerateDefaultHeroImage, useGetDefaultStartTimeSlot } from '../../../hooks';
import type { CreateEventFormValues } from '../CreateEventForm';

const DEFAULT_DURATION = 30;
const DEFAULT_EVENT_TYPE = 'video_conference';

export const useGetInitialValues = (slotStart?: SlotStart) => {
  const getDefaultStartTimeSlot = useGetDefaultStartTimeSlot();
  const heroImage = useGenerateDefaultHeroImage();
  const formatTime = useFormatTime();

  return useMemo((): Partial<CreateEventFormValues> => {
    const startDate = getDatePickerDateType(slotStart?.date ?? new Date());

    const date = slotStart?.isTimeSpecific ? slotStart.date : getDefaultStartTimeSlot(startDate);

    const startTime = formatTime(date);

    return {
      duration: DEFAULT_DURATION,
      featuredInChannels: false,
      heroImage,
      showInChannels: false,
      startDate,
      startTime,
      type: DEFAULT_EVENT_TYPE,
    };
  }, [slotStart, getDefaultStartTimeSlot, formatTime, heroImage]);
};
